"use strict";

var _classCallCheck = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Aggregates assessment results into a single score.
 *
 * @memberOf module:parsedPaper/assess
 *
 * @abstract
 */

var ScoreAggregator = /*#__PURE__*/function () {
  function ScoreAggregator() {
    _classCallCheck(this, ScoreAggregator);
  }

  _createClass(ScoreAggregator, [{
    key: "aggregate",

    /**
     * Aggregates the given assessment results into a single score.
     *
     * @param {AssessmentResult[]} results The assessment results.
     *
     * @returns {number} The aggregated score.
     *
     * @abstract
     */
    value: function aggregate(results) {
      // eslint-disable-line no-unused-vars
      console.warn("'aggregate' must be implemented by a child class of 'ScoreAggregator'");
    }
  }]);

  return ScoreAggregator;
}();

exports.default = ScoreAggregator;